export enum ButtonTypes {
    ADD = 'plus',
    EDIT = 'edit',
    DELETE = 'trash',
    LOCKED = 'locked',
    HOUSE = 'house'
}